<template>
  <v-app id="login">
    <v-main class="background-login">
      <v-container fluid right class="text-center v-center">
        <v-alert color="blueKonect" dark dense> Plataforma de clientes </v-alert>
      </v-container>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6 class="d-flex align-content-center flex-wrap">
                <logo />
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card class="rounded-xl" color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5 font-weight-bold">Iniciar sesión</v-card-title>
                    <v-card-text>
                      <v-text-field
                        v-model="username"
                        :disabled="loading"
                        prepend-icon="mdi-account"
                        required
                        autocomplete="off"
                        label="Correo"
                        @input="$v.username.$touch()"
                        @blur="$v.username.$touch()"
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="password"
                        type="password"
                        :disabled="loading"
                        prepend-icon="mdi-lock"
                        required
                        autocomplete="off"
                        label="Contraseña"
                        @input="$v.password.$touch()"
                        @blur="$v.password.$touch()"
                      >
                      </v-text-field>
                      <v-btn text small :disabled="loading" style="text-transform: none !important" @click="recovery()">¿Has olvidado tu contraseña?</v-btn>
                    </v-card-text>
                    <v-card-actions>
                      <div class="pl-3">v{{ version }}</div>
                      <v-spacer></v-spacer>
                      <v-btn type="submit" text :loading="loading">Entrar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ errorList[codeError] }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <main-footer />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import logo from "@/components/Logo";
import mainFooter from "@/components/Footer";
import { errormsg } from "@/components";
import services from "@/utils/services";
import errorList from "@/utils/errorsList";

export default {
  name: "login",
  components: { logo, mainFooter, errormsg },
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(50),
    },
    password: {
      required,
      maxLength: maxLength(50),
    },
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    loading: false,
    error: false,
    auth: false,
    message: "",
    errorList,
    host: process.env.VUE_APP_API_SERVER,
    path: "/pub/login",
    username: "",
    password: "",
    codeError: "",
  }),
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("El campo es obligatorio");
      !this.$v.username.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("El campo es obligatorio");
      !this.$v.password.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
  },
  methods: {
    ...mapActions("general", ["newUser"]),
    clear() {
      this.$v.$reset();
      this.username = "";
      this.password = "";
    },
    forgot() {
      this.$router.push("/forgot");
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.login();
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    recovery() {
      this.$router.push("/reset/recovery");
    },
    login() {
      if (!navigator.onLine) {
        this.codeError = "INTERNET_DISCONNECTED";
        this.error = true;
      } else {
        this.loading = true;

        setTimeout(() => {
          this.axios
            .post(this.host + this.path, {
              data: {
                email: this.username,
                password: this.password,
                dispositivo: {
                  idunico: "0",
                  modelo: "0",
                  sistema_operativo: "0",
                },
              },
            })
            .then((response) => {
              let res = response.data;
              for (let i = 0; i < res.roles.length; i++) {
                if (res.roles[i] == "CLIENTE_KONECT") {
                  this.auth = true;
                }
              }
              if (this.auth == true) {
                this.$session.start();
                this.$session.set("jwt", res.token);
                this.$session.set("usr", this.username);
                this.$session.set("rol", res.roles);
                this.newUser({ usr_nm: this.username, perfil: res.roles });

                // this.$router.push("/client/home");
              } else {
                this.error = true;
                this.codeError = "UNAUTHORIZED_ACCESS";
              }
            })
            .catch((error) => {
              this.error = true;
              this.codeError = error.response.data.code;
            })
            .finally(() => {
              this.loading = false;
              this.auth = false;
              services
                .ws("get", "dataPolicies")
                .then((res) => {
                  if (res.data.wasAgreed) {
                    this.$router.push("/client/home");
                  } else {
                    this.$router.push("/privacyNotice/" + "update");
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            });
        }, 300);
      }
    },
    closeMsg() {
      this.error = false;
    },
  },
};
</script>

<style scoped>
.background-login {
  background-color: white !important;
}
</style>
